import { ArrowRightOutlined, SnippetsOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Button } from 'antd';
import { DocumentTypeText, DocumentType } from 'commons/types/documentsTypes';

interface DocumentItemProps {
  type: DocumentType;
  date?: string;
  onClick?: () => void;
  clickable?: boolean;
}

export default function DocumentItem({
  type,
  date = '',
  onClick = () => {},
  clickable = false,
}: DocumentItemProps) {
  return (
    <div className='flex flex-row justify-between bg-primary-light rounded-2xl px-2 py-4 mb-1 mx-2'>
      <div className='flex flex-row overflow-hidden text-ellipsis'>
        <SnippetsOutlined className='text-3xl mr-3' />
        <div className='flex flex-col justify-start text-left mt-2 ml-2'>
          <p className='font-semibold text-sm m-0'>{DocumentTypeText[type]}</p>
          <p className='font-light text-sm m-0'>
            {dayjs(date, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('LL')}
          </p>
        </div>
      </div>
      {clickable && (
        <Button
          type='link'
          onClick={onClick}
          className='!inline-flex !items-center !justify-center !text-primary !h-12 !text-sm !p-0 !pl-4'
        >
          télécharger <ArrowRightOutlined className='text-xs' />
        </Button>
      )}
    </div>
  );
}
